(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    const applyContactObject = () => {
    if (new URLSearchParams(window.location.search).get('object') === 'katalysator') {
      document.querySelectorAll('[data-precision-contact-object]').forEach((input) => {
        if (!input.value) input.value = 'Bil / katalysator';
        input.disabled = false;
        const context = input.form?.querySelector('[data-precision-contact-context]');
        if (context) context.hidden = false;
      });
    }
  };
  applyContactObject();
  document.addEventListener('shopify:section:load', applyContactObject);
  } catch(e) { console.error(e); }
})();

})();
